import { IUser, IUserShare } from '@interfaces';

export const getUserName = (user: IUser | IUserShare) => `${user?.firstName || ''} ${user?.lastName || ''}`.trim();
